import React from "react";
import { Link } from "react-router-dom";

const CheckoutSuccess = () => {
  return (
    <div className="w-11/12 h-max  sm:w-10/12 md:w-9/12 lg:w-[7/12] section-padding py-4 sm:py-6 md:py-8 relative m-auto md:w-max bg-base-100 mt-[15%] shadow-xl rounded-md border border-gray-300">
      <h1 className="section-heading text-left mb-2">Checkout Successful</h1>
      <p className="section-desc my-8 w-full">
        Thank you for your purchase. If you shared your email, you will be
        notified of any updates regarding your package.
      </p>
      <Link to="/" className="p-0 m-0">
        <button className="btn btn-primary">Back to home</button>
      </Link>
    </div>
  );
};

export default CheckoutSuccess;
